import { useMutation } from '@tanstack/vue-query'
import { AxiosError } from 'axios'
import {
  TDefaultError,
  TToken,
  TLoginForm,
  TDefaultOptions,
  TRecoverForm,
  TResetPasswordForm,
} from '@/core/types'
import api from '@/core/config/axios'

export const useLogin = (options: TDefaultOptions<TToken, TLoginForm>) =>
  useMutation<TToken, AxiosError<TDefaultError>, TLoginForm>({
    mutationFn: (payload: TLoginForm) =>
      api
        .post<TToken>('/v1/auth/login', payload)
        .then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useLogout = (options: TDefaultOptions<any, any>) =>
  useMutation<any, AxiosError<TDefaultError>, any>({
    mutationFn: () =>
      api.post<any>('/v1/auth/logout', {}).then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useRequestPasswordChange = (
  options: TDefaultOptions<any, TRecoverForm>,
) =>
  useMutation<any, AxiosError<TDefaultError>, TRecoverForm>({
    mutationFn: (payload: TRecoverForm) =>
      api
        .post<any>('/v1/auth/password-change/request', payload)
        .then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })

export const useResetPassword = (
  options: TDefaultOptions<any, TResetPasswordForm>,
) =>
  useMutation<any, AxiosError<TDefaultError>, TResetPasswordForm>({
    mutationFn: (payload: TResetPasswordForm) =>
      api
        .post<any>('/v1/auth/password-change/reset', payload)
        .then((response) => response.data),
    onSuccess: options?.handlers?.onSuccess,
    onError: options?.handlers?.onError,
  })
